import {Subscription} from 'rxjs/Rx';
import {
    Component, OnInit, OnDestroy, ElementRef,
    Renderer, AfterViewInit, AfterContentInit
} from '@angular/core';
import {Router} from '@angular/router';

import {LayoutService} from '../layout.service';
import {
    SYSTEM_NAME_EPC,
    SYSTEM_NAME_ETD,
    SYSTEM_NAME_ISBN,
    SYSTEM_NAME_ROOMBOOK,
    SYSTEM_NAME_ZP,
    SYSTEM_NAME_UIK,
    SYSTEM_NAME_HELPDESK,
    SYSTEM_NAME_TOOLS,
    SYSTEM_NAME_LIBADMIN, SYSTEM_NAME_HELIOS
} from '../../../+app-custom/constants';
import {
    trigger,
    state,
    style,
    transition,
    animate
} from '@angular/animations'
import { AuthenticationService } from 'app/+app-custom/services/authentication.service';
import { AppRedirectService } from 'app/+app-custom/services/app-redirect.service';

@Component({
    selector: 'app-sa-shortcut',
    templateUrl: './shortcut.component.html',
    animations: [
        trigger('shortcutState', [
            state('out', style({
                height: 0,
            })),
            state('in', style({
                height: '*',
            })),
            transition('out => in', animate('250ms ease-out')),
            transition('in => out', animate('250ms 300ms ease-out'))
        ])
    ]
})
export class ShortcutComponent implements OnInit, AfterViewInit, AfterContentInit, OnDestroy {
    public state = 'out';
    private layoutSub: Subscription;
    private documentSub: any;

    constructor(private layoutService: LayoutService,
                private router: Router,
                private renderer: Renderer,
                private el: ElementRef,
                private appRedirectService: AppRedirectService) {
    }

    shortcutTo(route) {
        this.router.navigate(route);
        this.layoutService.onShortcutToggle(false);
    }

    ngOnInit() {

    }

    listen() {
        this.layoutSub = this.layoutService.subscribe((store) => {
            this.state = store.shortcutOpen ? 'in' : 'out';

            if (store.shortcutOpen) {
                this.documentSub = this.renderer.listenGlobal('document', 'mouseup', (event) => {
                    if (!this.el.nativeElement.contains(event.target)) {
                        this.layoutService.onShortcutToggle(false);
                        this.documentUnsub()
                    }
                });
            } else {
                this.documentUnsub()
            }
        })
    }

    ngAfterContentInit() {
        this.listen()

    }

    ngAfterViewInit() {
    }

    ngOnDestroy() {
        this.layoutSub.unsubscribe();
    }

    documentUnsub() {
        this.documentSub = null
    }

    // Redirects

    redirectEpc() {
        this.appRedirectService.redirectEpc();
    }

    redirectEtd() {
        this.appRedirectService.redirectEtd();
    }

    redirectIsbn() {
        this.appRedirectService.redirectIsbn();
    }

    redirectHelios() {
        this.appRedirectService.redirectHelios();
    }

    redirectRoombook() {
        this.appRedirectService.redirectRoombook();
    }

    redirectZp() {
        this.appRedirectService.redirectZp();
    }

    redirectUik() {
        this.appRedirectService.redirectUik();
    }

    redirectHelpdesk() {
        this.appRedirectService.redirectHelpdesk();
    }

    redirectTools() {
        this.appRedirectService.redirectTools();
    }

    redirectLibadmin() {
        this.appRedirectService.redirectLibadmin();
    }

    // Permission check

    isEpcAllowed() {
        return AuthenticationService.checkSystemAccessPermission(SYSTEM_NAME_EPC);
    }

    isEtdAllowed() {
        return AuthenticationService.checkSystemAccessPermission(SYSTEM_NAME_ETD);
    }

    isHeliosAllowed() {
        return AuthenticationService.checkSystemAccessPermission(SYSTEM_NAME_HELIOS);
    }

    isIsbnAllowed() {
        return AuthenticationService.checkSystemAccessPermission(SYSTEM_NAME_ISBN);
    }

    isRoombookAllowed() {
        return AuthenticationService.checkSystemAccessPermission(SYSTEM_NAME_ROOMBOOK);
    }

    isZpAllowed() {
        return AuthenticationService.checkSystemAccessPermission(SYSTEM_NAME_ZP);
    }

    isUikAllowed() {
        return AuthenticationService.checkSystemAccessPermission(SYSTEM_NAME_UIK);
    }

    isHelpdeskAllowed() {
        return AuthenticationService.checkSystemAccessPermission(SYSTEM_NAME_HELPDESK);
    }

    isToolsAllowed() {
        return AuthenticationService.checkSystemAccessPermission(SYSTEM_NAME_TOOLS);
    }

    isLibadminAllowed() {
        return AuthenticationService.checkSystemAccessPermission(SYSTEM_NAME_LIBADMIN);
    }

}



// WEBPACK FOOTER //
// ./src/app/shared/layout/shortcut/shortcut.component.ts